import React from "react";
import { Grid, Label, Popup } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarCheck } from "@fortawesome/pro-regular-svg-icons";
import { faCheckCircle, faTimesCircle, faEnvelope } from "@fortawesome/pro-solid-svg-icons";
import { withTranslation } from "react-i18next";
import moment from "moment";

import { round2 } from "../../util/common";
import "./CheckInOptionalServices.css";

const CHECKIN_COMMUNICATION_RESULT_STATUS = {
  NOT_SENT: 0,
  PENDING: 1,
  SUCCESS: 2,
  FAILED: 3,
};

const CheckInOptionalServices = ({ disabled, t, includeVAT, vat, services, onHandleCheckInCom, interventions }) => {
  if (!services || !services.length || services.every(service => !service.visible)) return null;

  services.sort((a, b) => (a.id < b.id ? 1 : a.id > b.id ? -1 : 0));

  return (
    <>
      <Grid className="optional-services-container">
        <Grid.Row className="optional-services-header-container">
          <Grid.Column width={9}>
            <FontAwesomeIcon icon={faCalendarCheck} className="optional-services-header-icon" />
            <span className="optional-services-header-title">{t("checkin_service").message || "Online check-in services"}</span>
          </Grid.Column>
          <Grid.Column width={2}>
            <span className="optional-services-header-title-small">{t("no_vat_price").message || "Excl. VAT"}</span>
          </Grid.Column>
          <Grid.Column width={2}>{includeVAT && <span className="optional-services-header-title-small">{t("vat_price").message || "Incl. VAT"}</span>}</Grid.Column>
          <Grid.Column width={3}>
            <span className="optional-services-header-title-small -pull-right">{t("ACTION").message || "ACTION"}</span>
          </Grid.Column>
        </Grid.Row>

        {services
          .filter(item => item.visible)
          .map(item => {
            const notificationEmailItemActive =
              [CHECKIN_COMMUNICATION_RESULT_STATUS.SUCCESS, CHECKIN_COMMUNICATION_RESULT_STATUS.FAILED].includes(item.status) || item.sent_to_lef;

            return (
              <Grid.Row key={"service_result_" + item.id} className="optional-services-item">
                <Grid.Column width={9}>
                  <span className="optional-services-remark">{item.name}</span>
                </Grid.Column>
                <Grid.Column width={2}>
                  <span className="optional-services-price">{round2(item.price)}</span>
                </Grid.Column>
                <Grid.Column width={2}>{includeVAT && <span className="optional-services-price">{round2(round2(item.price) * (1 + vat / 100))}</span>}</Grid.Column>
                <Grid.Column width={3}>
                  <div className={"optional-services-action -pull-right" + (disabled ? " disabled" : "")}>
                    <Label
                      onClick={() => {
                        !disabled &&
                          onHandleCheckInCom({
                            result: item,
                            openModalConvertToIntervention:
                              !item.receptionist_handled && item.can_convert_to_intervention && !interventions?.some(i => i.check_in_result_id === item.id),
                          });
                      }}
                    >
                      <FontAwesomeIcon
                        className={disabled ? "" : "-cursor-pointer-no-color"}
                        icon={item.receptionist_handled ? faCheckCircle : faTimesCircle}
                        color={item.receptionist_handled ? "green" : "red"}
                      />
                    </Label>
                  </div>

                  {(item.notification_email || item.sent_to_lef) && (
                    <div className="optional-services-action -pull-right no-cursor">
                      <Popup
                        wide
                        position="top right"
                        trigger={
                          <Label color={notificationEmailItemActive ? "blue" : ""}>
                            <FontAwesomeIcon icon={faEnvelope} color={notificationEmailItemActive ? "white" : "grey"} />
                          </Label>
                        }
                        content={() => {
                          const emailContent = () => {
                            if (item.status === CHECKIN_COMMUNICATION_RESULT_STATUS.SUCCESS)
                              return (
                                <div>
                                  {t("sent_to_notification_email", {
                                    email: item.notification_email,
                                    time: moment(item.updated_on).format("HH:mm"),
                                    date: moment(item.updated_on).format("DD-MM-YYYY"),
                                  }).message ||
                                    `Sent to ${item.notification_email} at ${moment(item.updated_on).format("HH:mm")} on ${moment(item.updated_on).format("DD-MM-YYYY")}`}
                                </div>
                              );
                            if (item.status === CHECKIN_COMMUNICATION_RESULT_STATUS.PENDING)
                              return (
                                <div>
                                  {t("sending_to").message || "Sending to"} {item.notification_email}
                                </div>
                              );
                            if (item.status === CHECKIN_COMMUNICATION_RESULT_STATUS.FAILED)
                              return (
                                <>
                                  <div>{`${t("failed_to_send_to").message || "Failed to send to"} ${item.notification_email}`}</div>
                                  <div>{item.reason}</div>
                                </>
                              );
                            return null;
                          };

                          return (
                            <div>
                              {emailContent()}
                              {item.notification_email && item.sent_to_lef && <hr />}
                              {item.sent_to_lef && (
                                <div>
                                  {t("sent_to_lef_at", {
                                    time: moment(item.sent_to_lef_at).format("HH:mm"),
                                    date: moment(item.sent_to_lef_at).format("DD-MM-YYYY"),
                                  }).message || `Sent to LEF at ${moment(item.sent_to_lef_at).format("HH:mm")} on ${moment(item.sent_to_lef_at).format("DD-MM-YYYY")}`}
                                </div>
                              )}
                            </div>
                          );
                        }}
                      />
                    </div>
                  )}
                </Grid.Column>
              </Grid.Row>
            );
          })}
      </Grid>
    </>
  );
};

export default withTranslation()(CheckInOptionalServices);
